<br />
<div *ngIf="reset === 'reset-username'" class="reset-container resetpass-wrap">
  <div class="header">Forgot Username</div>
  <div class="reset-inner">
    <div>
      <div class="mt-1 user-info">Provide Your User Information</div>
      <div class="provide-user-info user-info">
        <p>
          Please provide the account user's information below to receive the username via email.
        </p>
      </div>
      <div class="req m-top-custom"><span class="astrick">*</span> Required field</div>
    </div>
    <div class="field-style">
      <div class="row">
        <div class="userResetField col-md-4 mr-2">
          <label class="userField"
            >First Name <span class="astrick">*</span></label
          >
          <app-form-field
            [placeholderName]="'Enter your first name'"
            [labelName]="'First Name'"
            [controlName]="'firstName'"
            [formGroup]="resetUsernameformGroup"
            [txtSize]="28"
          ></app-form-field>
        </div>
        <div class="userResetField col-md-4">
          <label class="userField">
            Last Name <span class="astrick">*</span></label
          >
          <app-form-field
            [placeholderName]="'Enter your last name'"
            [labelName]="'Last Name'"
            [controlName]="'lastName'"
            [formGroup]="resetUsernameformGroup"
            [txtSize]="28"
          ></app-form-field>
        </div>
      </div>
      <div class="row" class="userResetField col-md-4 mt-4">
        <label class="userField"
          >Email Address <span class="astrick">*</span></label
        >
        <app-form-field
          [placeholderName]="'Enter your email address'"
          [labelName]="'Email Address'"
          [typeOfInput]="'email'"
          [controlName]="'email'"
          [formGroup]="resetUsernameformGroup"
          [txtSize]="28"
        ></app-form-field>
      </div>
      <div class="col-md-3"></div>
    </div>
    <div
      class="userResetField userset col-md-12 m-res-btn"
      [ngClass]="{
        'bp-5': usernameResetSuccess === false && usernameResetError === false
      }"
    >
      <button
        class="next-btn provide-user-info"
        [ngClass]="{ disabled: !resetUsernameformGroup.valid }"
        [disabled]="!resetUsernameformGroup.valid"
        (click)="ResetUsername()"
      >
        Submit
      </button>
    </div>
    <div
      *ngIf="usernameResetSuccess === true && usernameResetError === false"
      class="row usernameReset m-res-btn"
    >
      <div class="userResetField userSuccess col-md-12">
        <p >Your username has been sent to the email provided.</p>
      </div>
    </div>
    <div
      *ngIf="usernameResetSuccess === false && usernameResetError === true"
      class="row usernameReset m-res-btn"
    >
      <div class="userResetField col-md-12 tm-1" >
        <p class="error-message">
          One or more pieces of information entered do not match our records.
        </p>
        <p class="error-message">
          Please try again or contact us at 1-888-256-9929 for additional assistance.
        </p>
        <p class="userResetNew">
          Alternatively, click on the Register button below if you do not have a current account.
        </p>
      </div>
    </div>
    <div class="row button-width m-res-btn d-flex">
      <div>
        <button
          class="next-btn prev-btn provide-user-info"
          (click)="redirectLogin()"
        >
          &lt; Back to Login
        </button>
      </div>
      <div
        *ngIf="usernameResetSuccess === false && usernameResetError === true"
      >
        <button
          class="next-btn provide-user-info btn-register"
          (click)="redirectRegister()"
        >
          Register
        </button>
      </div>
    </div>
  </div>
</div>


<div *ngIf="reset === 'reset-username'" class="reset-container resetpass-wrap" class="forgt-user-screen-btn-containen">

<div class="forgt-screen-btn-container">
  <div class="row button-width">
    <div>
      <button
        class="next-btn prev-btn provide-user-info"
        (click)="redirectLogin()"
      >
        &lt; Back to Login
      </button>
    </div>
  </div>
  <div
  class="userResetField userset col-md-12"
  [ngClass]="{
    'bp-7': usernameResetSuccess === false && usernameResetError === false
  }"
>
  <button
    class="next-btn provide-user-info"
    [ngClass]="{ disabled: !resetUsernameformGroup.valid }"
    [disabled]="!resetUsernameformGroup.valid"
    (click)="ResetUsername()"
    >
    Submit
  </button>
</div>
</div>
<div class="reg-btn"
    *ngIf="usernameResetSuccess === false && usernameResetError === true"
  >
    <a (click)="redirectRegister()" class="register-btn-a">Register</a>
  </div>
</div>



<div
  *ngIf="reset === 'reset-password' && registerationSuccess === false"
  class="reset-container resetpass-wrap"
>
  <div *ngIf="confirmPass === true">
    <div class="header">Forgot Password</div>
    <div class="reset-inner">
      <div>
        <div class="mt-1 user-info">Confirm Username & Email Address</div>
        <div class="provide-user-info user-space">
          <p>Please provide the username and email address for your account.</p>
        </div>
        <div class="req m-top-custom required-field"><span class="astrick">*</span> Required field</div>
      </div>
      <div class="field-style">
        <div class="row mb-4">
          <div class="userResetField col-md-5 pt-1">
            <label class="userField mt-1"
              >Username <span class="astrick">*</span></label
            >
            <app-form-field
              [placeholderName]="'Enter your username '"
              [labelName]="'User Name'"
              [controlName]="'userName'"
              [formGroup]="resetPasswordformGroup"
              [txtSize]="28"
              [className]="forgot - password - form - field"
            ></app-form-field>
          </div>
        </div>
        <div class="userResetField col-md-5">
          <label class="userField"
            >Email Address <span class="astrick">*</span></label
          >
          <app-form-field
            [placeholderName]="'Enter your email address'"
            [labelName]="'Email Address'"
            [typeOfInput]="'email'"
            [controlName]="'email'"
            [formGroup]="resetPasswordformGroup"
            [txtSize]="28"
            [className]="forgot - password - form - field"
          ></app-form-field>
        </div>
        <div>
          <div
            class="m-res-btn userResetField userset col-md-12 bp-4"
          >
            <button
              class="next-btn"
              [ngClass]="{ disabled: !resetPasswordformGroup.valid }"
              [disabled]="!resetPasswordformGroup.valid"
              (click)="ResetPassword()"
            >
              Next
            </button>
          </div>
        </div>
        <div class="m-res-btn row usernameReset">
          <div class="mt-3 userResetField col-md-12">
            <button
              class="next-btn prev-btn provide-user-info register-btn"
              (click)="redirectLogin()"
            >
              &lt; Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  

  <div *ngIf="securityQuestionScreen === true">
    <div class="header">Answer Security Questions</div>
    <div class="reset-inner">
      <div>
        <div class="mt-1 user-info-sec-ques">Answer Security Questions</div>
        <div class="provide-user-info" *ngIf="!blnShoweErrorBottom">
          <p>
            Please answer the following security questions to reset your password.
          </p>
        </div>
        <div class="req m-top-custom"><span class="astrick">*</span> Required field</div>
      </div>
      <div class="field-style">
        <div class="mt-0 row securityQues">
          <div
            class="userResetField col-md-6 mb-2"
            *ngFor="let item of securityQuesList; let i = index"
          >
            <label class="userField"
             class="security-question-ans">{{ item.Question }}<span class="ml-1 astrick">*</span>
            </label>
            <app-form-field
              [placeholderName]="'Enter your answer'"
              [labelName]="'Answer'"
              [controlName]="'answer' + (i + 1)"
              [formGroup]="securityQuestionsformGroup"
              [txtSize]="28"
              [className]="forgot - password - form - field"
            ></app-form-field>
          </div>
        </div>
        <div class="mt-3">
          <div
            class="m-res-btn userResetField userset col-md-12 mt-2"
            style="text-align: left"
          >
            <button
              class=" next-btn"
              [ngClass]="{ disabled: !securityQuestionsformGroup.valid }"
              [disabled]="!securityQuestionsformGroup.valid"
              (click)="validateSecurityQuestions()"
            >
              Next
            </button>
          </div>
        </div>
        <div class="forgetAnsMsg">
          <span
            ><img
              class="toolTip"
              src="../../../../assets/images/caution_icon.svg"
          /></span>
          <span style="padding-top: 0.15rem" class="forgotAns"
            >Please contact us if you cannot remember the answers to your
            security questions.</span
          >
        </div>
        <div class="m-res-btn userResetField col-md-12">
          <button
            class="next-btn prev-btn provide-user-info"
            (click)="redirectConfirmPassScreen()"
          >
            &lt; Back
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="newPasswordResetScreen === true">
    <div class="header">Confirm New Password</div>
    <div class="reset-inner">
      <div>
        <div class="mt-1 user-info">Confirm Your New Password</div>
        <div class="mb-0 provide-user-info" style="line-height: 1.4375rem;">
          <p>Please choose a new password.</p>
        </div>
        <div class="req m-top-custom"><span class="astrick">*</span> Required field</div>
      </div>
      <div class="col-md-5 userResetField">
        <label class="userField new-pass">
          New password <span class="astrick">*</span>
        </label>
        <i *ngIf="newPasswordShowPasswordIcon" class="fa fa-eye eye-icon" aria-hidden="true" (click)="toggleNewPassword()"></i>
        <i *ngIf="!newPasswordShowPasswordIcon" class="fa fa-eye-slash eye-icon" aria-hidden="true" (click)="toggleNewPassword()"></i>
        <input
        [ngClass]="{
          'border-invalid': !password1.valid && password1.touched,
            'border-valid': password1.valid
          }"
          [type]="newPasswordShowPasswordIcon ? 'text':'password'"
          class="form-control"
          id="password"
          name="password"
          [(ngModel)]="password"
          required
          #password1="ngModel"
          (keyup)="checkpassword(password)"
          (keyup)="passwordValidation(true)"
          placeholder="Enter new password"
          value="password"
          minlength="8"
          maxlength="30"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,30}$"
          />

        <div
          *ngIf="!password1.valid && password1.touched"
          class=" password-error-message"
        >
          New Password Required
        </div>
        <ng-container class="passwordConfirmation" *ngIf="password">
          <p
            class="mt-2 passwordConfirmation"
            [ngClass]="{
              'text-danger': !blnHasCapital,
              'text-white': blnHasCapital
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check-circle-o': blnHasCapital,
                'fa-times-circle': !blnHasCapital
              }"
              aria-hidden="true"
            ></i>
            At least 1 upper case character
          </p>
          <p
            class="passwordConfirmation"
            [ngClass]="{
              'text-danger': !blnLowerCase,
              'text-white': blnLowerCase
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check-circle-o': blnLowerCase,
                'fa-times-circle': !blnLowerCase
              }"
              aria-hidden="true"
            ></i>
            At least 1 lower case character
          </p>
          <p
            class="passwordConfirmation"
            [ngClass]="{
              'text-danger': !blnHasOneNumber,
              'text-white': blnHasOneNumber
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check-circle-o': blnHasOneNumber,
                ' fa-times-circle': !blnHasOneNumber
              }"
              aria-hidden="true"
            ></i>
            At least 1 numeric digit
          </p>
          <p
            class="passwordConfirmation"
            [ngClass]="{
              'text-danger': !blnHasSpecialChar,
              'text-white': blnHasSpecialChar
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check-circle-o': blnHasSpecialChar,
                ' fa-times-circle': !blnHasSpecialChar
              }"
              aria-hidden="true"
            ></i>
            1 non-alphanumeric character between [!@#$%^&*]
          </p>
          <p
            class="passwordConfirmation"
            [ngClass]="{
              'text-danger': !blnHasLength,
              'text-white': blnHasLength
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check-circle-o': blnHasLength,
                'fa-times-circle': !blnHasLength
              }"
              aria-hidden="true"
            ></i>
            Password must be between 8 to 30 characters.
          </p>
        </ng-container>
      </div>
      <div class="col-md-5 mt-3 userResetField">
        <label class="userField">
          Confirm New Password <span class="astrick">*</span>
        </label>
        <i *ngIf="confirmPasswordShowPasswordIcon" class="fa fa-eye eye-icon" aria-hidden="true" (click)="toggleConfirmPassword()"></i>
        <i *ngIf="!confirmPasswordShowPasswordIcon" class="fa fa-eye-slash eye-icon" aria-hidden="true" (click)="toggleConfirmPassword()"></i>
        <input
          [ngClass]="{
            'border-invalid': !password2.valid && password2.touched,
            'border-valid': password2.valid
          }"
          [type]="confirmPasswordShowPasswordIcon ? 'text':'password'"
          class="form-control"
          id="confirmPassword"
          name="confirmPassword"
          (value)="(confirmPassword)"
          placeholder="Confirm new password"
          [(ngModel)]="confirmPassword"
          required
          #password2="ngModel"
          minlength="8"
          maxlength="30"
          (keyup)="confirmPasswords(false)"
        />
        <div
          *ngIf="!password2.valid && password2.touched"
          class=" password-error-message"
        >
          Confirm New Password Required
        </div>
        <div
          *ngIf="password !== confirmPassword"
          class="password-error-message"
        >
          Password not matching
        </div>
      </div>
      <div class="userResetField col-md-12 mt-4 mb-4 userset margin-bottom-0">
        <button
          class="m-res-btn next-btn provide-user-info mb-3 margin-bottom-0"
          [ngClass]="{disabled: (password !== confirmPassword || !password || !confirmPassword || !blnPasswordBoxValid)}"
          [disabled]="(password !== confirmPassword || !password || !confirmPassword || !blnPasswordBoxValid)"
          (click)="confirmPasswordd()"
        >
          Submit
        </button>
      </div>
      <div class="mt-3 m-res-btn userResetField col-md-12 margin-top-0">
        <button
          class="mt-4 next-btn prev-btn provide-user-info"
          (click)="redirectToSecurityQuesScreen()"
        >
          &lt; Back
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reset === 'reset-password' && registerationSuccess === false && confirmPass === true" class="forgt-screen-btn-container for-m-screen">
  <div class="row button-width">
      <button
        class="next-btn prev-btn provide-user-info"
        (click)="redirectLogin()"
      >
        &lt; Back to Login
      </button>
  </div>
  <div
  class="userResetField userset col-md-12"
  [ngClass]="{
    'bp-7': usernameResetSuccess === false && usernameResetError === false
  }"
 >
   <button
    class="next-btn"
    [ngClass]="{ disabled: !resetPasswordformGroup.valid }"
    [disabled]="!resetPasswordformGroup.valid"
    (click)="ResetPassword()"
    >
    Submit
   </button>
  </div>
</div>

<div *ngIf="reset === 'reset-password' && registerationSuccess === false && securityQuestionScreen === true" class="forgt-screen-btn-container for-m-screen">
  <div
  class="userResetField userset col-md-12"
  [ngClass]="{
    'bp-7': usernameResetSuccess === false && usernameResetError === false
  }"
 >
         <button
            class="next-btn prev-btn provide-user-info"
            (click)="redirectConfirmPassScreen()"
          >
            &lt; Back
         </button>
  </div>
  <div class="row button-width">    
    <button
            class=" next-btn"
            [ngClass]="{ disabled: !securityQuestionsformGroup.valid }"
            [disabled]="!securityQuestionsformGroup.valid"
            (click)="validateSecurityQuestions()"
          >
            Next
     </button>
</div>
</div>

<div *ngIf="reset === 'reset-password' && registerationSuccess === false && newPasswordResetScreen === true" class="forgt-screen-btn-container for-m-screen">
  <div class="row button-width">
      <button
      class="next-btn prev-btn provide-user-info"
      (click)="redirectToSecurityQuesScreen()"
      >
        &lt; Back
      </button>
    </div>
  <div
  class="userResetField userset col-md-12"
  [ngClass]="{
    'bp-7': usernameResetSuccess === false && usernameResetError === false
  }"
  >
      <button
        class="next-btn provide-user-info mb-3 margin-bottom-0"
        [ngClass]="{
          disabled:
            password !== confirmPassword || !password || !confirmPassword
        }"
        [disabled]="
          password !== confirmPassword || !password || !confirmPassword
        "
        (click)="confirmPasswordd()"
      >
      Submit
    </button>

  </div>
</div>

<div
  *ngIf="registerationSuccess === true"
  class="reset-container resetpass-wrap passReset m-res-last-screen"

>
  <div class="confirm-message message-center-confirm">
    <span class="pass-reset-tp-text">Password Reset</span>
    <div class="mt-3 confirm-message-text">
      <div class="confirm-message-text-container text-center">
        <p>Your password has been reset successfully</p>
      </div>
    </div>
    <div class="mt-4 btn-container margin-top-0 for-normal-screen">
      <button class="btn btn-style btnBackToLogin mb-3" (click)="backToLogin()">
        Continue to Login Screen
      </button>
    </div>
  </div>
</div>
<div  *ngIf="registerationSuccess === true" class="mt-4 btn-container margin-top-0 confirm-btn for-m-screen">
  <button style="width:93%;" class="btn btn-style btnBackToLogin mb-3 confirm button" (click)="backToLogin()">
    Continue to Login Screen
  </button>
</div>
<br />
